import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=ff8d22d2"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff8d22d2')) {
      api.createRecord('ff8d22d2', component.options)
    } else {
      api.reload('ff8d22d2', component.options)
    }
    module.hot.accept("./NavMenu.vue?vue&type=template&id=ff8d22d2", function () {
      api.rerender('ff8d22d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/NavMenu.vue"
export default component.exports